import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import ReportTable from "../common/ReportTable";
//import header from "../../assets/images/registrationHeader.png";
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Copyright from '../common/copyright';
import Header from "../common/header";
import { useHistory, useLocation, Redirect, Route } from "react-router-dom";


export default function DetailedReport() {

    const location = useLocation()
    const history = useHistory()
    console.log("location", location.state)

    // const [name, setName] = useState('')
    // const [stateName, setStateName] = useState('')

    var name = ''
    var stateName = ''
    if(location.state != undefined && location.state.studentDetails != undefined){
        // setName(location.state.studentDetails.name)
        // setStateName(location.state.studentDetails.stateName)
        name = location.state.studentDetails.name
        stateName = location.state.studentDetails.stateName
    }

    const classes = useStyles();
    console.log("Hi from detailed report");
    return (
        <Route
            {...location.state}
            render={item =>
                (location.state !== undefined) ? (
                    <div className={classes.root}>
                        <Header
                            name={name}
                            location={stateName}
                            className={location.state.assessmentDetails.className}
                        />
                        <Container component="main" maxWidth="xl" className={classes.reportContainer}>
                            <Typography align="center" className={classes.timeTaken} variant="caption" component="div">
                                Time Taken : <span className={classes.hourText}>
                                    {/* {location.state.assessmentDetails.timeLimit - location.state.testData.completionDuration - 1} */}
                                    {location.state.testData.completionDuration}
                                </span> : <span className={classes.minuteText}>{60 - location.state.seconds} </span>
                            </Typography>

                            <ReportTable
                                answers={location.state.correctAnswerArray}
                                responses={location.state.responseArray}
                                percentage={((location.state.testData.correctQuesionCnt / location.state.testData.totalQuesionCnt) * 100)}
                            />
                        </Container>
                        <footer className={classes.footer}>
                            <Container maxWidth="sm">
                                <Copyright />
                            </Container>
                        </footer>
                    </div>)
                    :
                    (
                        <Redirect to={{ pathname: '/' }} />
                    )
            }
        />


    );
}


const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        flexDirection: 'column',
        minHeight: '100vh',
    },
    reportContainer: {
        //marginTop: '200px'
        marginTop: '25px'
    },
    timeTaken: {
        fontSize: 16,
        color: 'black',
        marginBottom: '25px'
    },
    minuteText: {
        backgroundColor: '#F05A29',
        color: 'white',
        padding: '2px',
        textAlign: 'center',
        borderRadius: '4px'
    },
    hourText: {
        backgroundColor: '#28A8E0',
        color: 'white',
        padding: '2px',
        textAlign: 'center',
        borderRadius: '4px'
    },
    footer: {
        padding: theme.spacing(3, 2),
        marginTop: 'auto',
        // backgroundColor:
        //     theme.palette.type === 'light' ? theme.palette.grey[200] : theme.palette.grey[800],
    },
}));